import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialPerfVsIndexCapsuleConfigState,
    PerfVsIndexCapsuleConfigState,
} from './PerfVsIndexCapsuleConfigState';
import { selectPerfVsIndexCapsuleState } from '../selectors';

export const buildPerfVsIndexCapsuleConfigSlice = () =>
    buildConfigSlice<PerfVsIndexCapsuleConfigState>(
        WidgetType.PERF_VS_INDEX_CAPSULE,
        selectPerfVsIndexCapsuleState,
        initialPerfVsIndexCapsuleConfigState
    );

export const usePerfVsIndexCapsuleConfigSlice = () =>
    useConfigSlice(buildPerfVsIndexCapsuleConfigSlice());

export type PerfVsIndexCapsuleConfigPayloadType =
    WidgetConfigSliceActionPayloadType<PerfVsIndexCapsuleConfigState>;
